<template lang="pug">
  div.item(:style="pos(pnum,num)")
    figure
      img(:src="'./static/side/' + item.code + '.svg'")
</template>

<script>
import store from '../../stores/index';
export default {
  name: 'Items',
  data () {
    return {
      parent: 0,
      child: 0,
      height: 0,
      $tar: {},
      $info: {},
      dragged: {},
      slits: []
    };
  },
  props: {
    pnum: Number,
    num: Number,
    dat: Object
  },
  computed: {
    infoitem () {
      return this.$store.getters.infoitem;
    }
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    },
    view () {
      this.update();
    }
  },
  methods: {
    update () {
      if (this.sets[this.number] !== undefined) {
        this.slits = this.sets[this.number].slits;
        this.height = this.c2p(this.sets[this.number].size[1]);
        if (this.slits !== undefined) {
          this.space = this.slits[this.pnum + 1].pos - this.slits[this.pnum].pos;
          let itm = this.slits[this.pnum].floor[this.num];
          if (itm.dat !== undefined) {
            this.items = itm.dat.item;
            for (let prop in this.items) {
              if (this.space === Number(this.items[prop].w)) {
                this.item = this.acopy(this.items[prop]);
                this.item.dat = itm.dat;
              }
            }
          }
          this.hole = Number(this.slits[0].slit.hole);
        }
      }
    },
    pos (i, s) {
      let top;
      let bottom;
      let height;
      let depth;
      let itm = this.slits[i].floor[s];
      if (itm.under) {
        top = 'auto';
        bottom = '0px';
        height = this.c2p(itm.h) + 'px';
      } else {
        top = (itm.y * (this.height / this.hole)) + 'px';
        bottom = 'auto';
        height = '';
      }
      depth = this.c2p(this.slits[i].floor[s].d) + 'px';
      return {
        width: depth,
        height: height,
        bottom: bottom,
        top: top
      };
    },
    open (e) {
      let dat = {
        left: this.mp(e).clientX,
        top: this.mp(e).clientY,
        display: true,
        item: this.item
      };
      store.commit('setInfoitem', dat);
      window.addEventListener('mouseout', this.mouseout, false);
      window.addEventListener('touchcancel', this.mouseout, false);
    },
    mousedown (e) {
      this.$tar = e.currentTarget;
      window.addEventListener('mouseup', this.mouseup, false);
      window.addEventListener('touchend', this.mouseup, false);
    },
    mouseout () {
      let dat = {
        display: false
      };
      store.commit('setInfoitem', dat);
      window.removeEventListener('mouseup', this.mouseup, false);
      window.removeEventListener('mousemove', this.mousemove, false);
      window.removeEventListener('mouseout', this.mouseout, false);
      window.removeEventListener('touchmove', this.mousemove, false);
      window.removeEventListener('touchcancel', this.mouseout, false);
      window.removeEventListener('touchend', this.mouseup, false);
    },
    mouseup (e) {
      if (!this.infoitem.display) {
        this.open(e);
      } else {
        this.mouseout();
      }
      window.removeEventListener('mouseup', this.mouseup);
      window.removeEventListener('touchend', this.mouseup);
    }
  },
  created () {
    this.update();
  },
  destroyed () {
    this.$el.removeEventListener('mousedown', this.mousedown);
    this.$el.removeEventListener('touchstart', this.mousedown);
  },
  mounted () {
    if ('ontouchstart' in window) {
      this.$el.addEventListener('touchstart', this.mousedown);
    } else {
      this.$el.addEventListener('mousedown', this.mousedown);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .item
    height 20px
    position absolute
    left 0
    filter drop-shadow(1px 1px 3px rgba(0,0,0,0.2))
    figure
      img
        width 100%
        height 100%

</style>



// WEBPACK FOOTER //
// src/components/side/FItem.vue